<script lang="ts" setup>
import { useSdk } from '~/sdk';
// @ts-ignore
import strtotime from 'locutus/php/datetime/strtotime';
// @ts-ignore
import date from 'locutus/php/datetime/date';
import VOrderDetail from '~/components/VOrderDetail.vue';

const route = useRoute();
const { user } = useAuth();
const config = useRuntimeConfig();
const { makePurchase } = useAnalytics();

const { data, refresh } = useAsyncData(async function () {
  return await useSdk().commerce.orderGet({
    id_order: route.query.id_order as string,
  });
});

onMounted(async function () {
  await refresh();

  if (data.value) {
    makePurchase(data.value);
  }
});

useHead({
  script: [
    {
      src: 'https://apis.google.com/js/platform.js?onload=renderOptIn',
      async: true,
      defer: true,
    },
    {
      innerHTML: `
        window.renderOptIn = function() {
          window.gapi.load('surveyoptin', function() {
            window.gapi.surveyoptin.render({
              "merchant_id": "${config.public.merchantId}",
              "order_id": "${route.query.id_order}",
              "email": "${user?.email}",
              "delivery_country": "${data.value?.iso_country_code ?? 'IT'}",
              "estimated_delivery_date": "${date('Y-m-d', strtotime('2 weekdays'))}",
            });
          });
        }
      `,
    },
  ],
});

</script>

<template>
  <div class="pt-10 w-full mx-auto max-w-4xl">
    <div v-if="data && data.products">
      <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ $t('Thanks for ordering') }}
      </p>
      <p class="mt-2 text-base text-gray-500">
        {{
          $t("We appreciate your order, we're currently processing it. so hang tight and we'll send you confirmation very soon!")
        }}
      </p>

      <VOrderDetail :order="(data as any)" />
    </div>
  </div>
</template>
